export class InformacionBasicaAgente {
    usuario: String;
    dni: String;
    nombreCompleto: String;
    constructor() {
        this.usuario = '';
        this.dni = '';
        this.nombreCompleto = '';
    }
}



// WEBPACK FOOTER //
// ./src/app/models/agente/informacio-basica-agente.class.ts